import React from "react";

interface DashboardCardProps {
  id?: string;
  title: string;
  countLabel: string;
  count: number;
  onSeeAll: () => void;
  children: React.ReactNode;
  seeAllProps?: React.ButtonHTMLAttributes<HTMLButtonElement>;
}

const DashboardCard: React.FC<DashboardCardProps> = ({
  id,
  title,
  countLabel,
  count,
  onSeeAll,
  children,
  seeAllProps,
}) => (
  <div className="flex-1 card shadow-md" id={id}>
    <div className="card-body flex flex-col items-center">
      <h2 className="card-title text-xl font-semibold mb-2 text-center">
        {title}
      </h2>
      <ul className="mb-4 w-full">{children}</ul>
      <div className="card-actions mt-auto flex flex-col items-center">
        <span className="text-sm text-base-content/75 mb-1">
          {count} {countLabel}
        </span>
        <button
          className="see-all-btn link link-primary"
          onClick={onSeeAll}
          {...seeAllProps}
        >
          See all
        </button>
      </div>
    </div>
  </div>
);

export default DashboardCard;